// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5696) return "static/chunks/5696.9784b67dddcdb58d.js";
	if (chunkId === 7733) return "static/chunks/7733.b9bbaa81e36690d6.js";
	if (chunkId === 4681) return "static/chunks/4681.f5d69039bbf651cc.js";
	if (chunkId === 1987) return "static/chunks/1987.1567fa31af0bc263.js";
	if (chunkId === 1280) return "static/chunks/1280.dd2e1739ed74fc15.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"6711":"8e1d74a4","9268":"aaea2bcf"}[chunkId] || chunkId) + "-" + {"4525":"760dc0ebc9cd7baf","5476":"bfe63937aa7be2ec","5615":"292165043e8bad2b","6528":"710b98ccc0c7e379","6711":"67d40a34638700d7","7062":"105a70e62d258e1f","7887":"2315023971f28e52","8249":"55edf95658b49375","8353":"c94354700cfc655b","9268":"25a5d10fc5a29801"}[chunkId] + ".js";
};